import moment from "moment"

export function calculateAge(dob: string | Date | undefined | null): number | null {
  if (!dob) return null
  const m = moment(dob)
  if (!m.isValid()) return null
  const age = moment().diff(m, 'years')
  if (age < 0) return null
  return age
}

export function formatDob(dob: string | Date | undefined | null): string {
  if (!dob) return '-'
  const m = moment(dob)
  if (!m.isValid()) return String(dob)
  const age = calculateAge(dob)
  const formatted = m.format('DD MMM YYYY')
  return age != null ? `${formatted} (${age} tahun)` : formatted
}

export function currencyFormatter(amount: number, currency = 'IDR') {
  if (currency === 'IDR') {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency,
      minimumFractionDigits: 0
    }).format(amount)
  } else {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency
    }).format(amount)
  }
}